import { Button, PlusLine } from '@revenuemarket/cds';
import { ResponseStatus } from '@revenuemarket/http';
import { overlays } from '@revenuemarket/overlays';
import { Toast } from '@revenuemarket/ui';
import { useRouter } from 'next/router';

import AnalysisEditConfirmModal from '~components/ui/Modal/AnalysisEditConfirmModal';
import useNavigationStore from '~components/ui/layout/Navigation/useNavigationStore';
import { useCreateAnalysis } from '~hooks/queries/analysis/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

import useAnalysisTableStore from './useAnalysisStore';

const AnalysisCreateButton = () => {
  const { companyId } = useDemoAwareCompanyId();
  const router = useRouter();
  const { setActiveKey } = useNavigationStore();
  const { mutateAsync: createAnalysis } = useCreateAnalysis();
  const { analysisData, setAnalysisData } = useAnalysisTableStore();

  const onCreate = async () => {
    const response = await createAnalysis({
      companyId,
    });
    const tableId = response?.Data?.data?.table?.id;

    if (response.Status === ResponseStatus.SUCCESS && tableId !== undefined) {
      Toast.success('분석이 생성되었습니다.');
      setAnalysisData({
        edited: false,
      });
      mixpanel.track(MIXPANEL_EVENT.ANALYSIS.CREATE);
      setActiveKey(undefined);
      router.push(`/clobe/analysis/${tableId}?defaultOpenPanel=true`);
    } else {
      Toast.error('분석 생성에 실패했습니다.');
    }
  };
  return (
    <Button
      icon={<PlusLine />}
      buttonSize="small"
      style={{
        width: 24,
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (analysisData?.edited) {
          overlays.open(({ isOpen, onClose }) => (
            <AnalysisEditConfirmModal
              open={isOpen}
              onCancel={onClose}
              onOk={() => {
                onCreate();
                onClose();
              }}
            />
          ));
          return;
        }
        onCreate();
      }}
    />
  );
};

export default AnalysisCreateButton;
